module.exports = __webpack_public_path__ + "static/media/returns_N.89742127.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/returns_N.png
// module id = 104
// module chunks = 0